import {Col, Row, Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import CardHistory from "../cards/cardHistory";
import LogoutButton from "../layout/logoutButton";
import ApiService from "../../services/ApiService";
import {useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import DateTimeUtils from "../../services/DateTimeUtils";

const Historical = () => {
    const [orderList, setOrderList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        ApiService.getUserOrderInfo().then((basketElement) => {
            createBasketItem(basketElement.basketDtoList);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleVediDettaglio = (e, bId) => {
        e.preventDefault();
        navigate(AppRoute.ORDER, {state: {basketId: bId}})
        // Add your logic for handling "Vedi dettaglio" button click if needed.
    };

    const createBasketItem = async (basketElements) => {
        const basketItemList = [];

        const activeBaskets = basketElements.filter(
            (basket) => basket.status === "Completed"
        ).sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate));
        for (const basketPayed of activeBaskets) {
            basketItemList.push(
                <Row className={'mb-4'}>
                    <Col xs={12}>
                        <p className={'fw-bold mb-1'}>{DateTimeUtils.convertToZHTimezoneFormat(basketPayed.creationDate.trimStart())}</p>
                        <CardHistory basketItem={basketPayed} />
                        <div className={'d-flex justify-content-end'}>
                            <Button
                                variant={'primary'}
                                className={'px-5 fw-bold'}
                                onClick={(e) => handleVediDettaglio(e, basketPayed.id)}
                            >
                                Vedi dettaglio
                            </Button>
                        </div>
                    </Col>
                </Row>
            );
        }

        setOrderList(basketItemList);
    };

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Storico Ordini</h2>
                            <p className={'mb-0 fw-bold'}>Conferma d'ordine e pagamento da stampare o salvare </p>
                            <p>Ulteriori comunicazioni non verranno spedite per e-mail</p>
                        </Col>
                    </Row>

                    {orderList.length > 0 ? orderList : "Nessun ordine presente"}

                </Col>
                <Col>
                    <div className={'w-100 mt-4 mt-lg-0 d-flex justify-content-end'}>
                        <LogoutButton/>
                    </div>
                </Col>
            </Row>


        </>

    );
}

export default Historical;
